import React, { useContext, useState } from 'react';
import { WorkspaceContext } from '../context/WorkspaceContext';
import WorkspaceServices from '../api/workspaceServices';

const WorkspaceForm = ({ id, onWorkspaceSaved }) => {
  const [mode, setMode] = useState('hidden');
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const { addWorkspace } = useContext(WorkspaceContext);

  const handleNameChange = (e) => {
    setName(e.target.value);
    generateSlug(e.target.value);
  }

  const handleSaveWorkspace = async () => {
    let workspace = { name, slug };
    if (id) workspace = { ...workspace, id };
    const newWorkspace = await WorkspaceServices.saveWorkspace(workspace);
    if (id) {
      addWorkspace(newWorkspace);
    }
    onWorkspaceSaved(newWorkspace);
    setName('');
    setSlug('');
    setMode('hidden');
  };

  const generateSlug = (name) => {
    const slug = name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    setSlug(slug);
    return slug;
  };

  return (
    <div>
      {mode === 'hidden' && !id && (
        <button onClick={() => setMode('edit')}>
          <span role="img" aria-label="add">➕</span>
        </button>
      )}
      {mode === 'edit' && (
        <form onSubmit={(e) => { e.preventDefault(); handleSaveWorkspace(); }}>
          <input
            type="text"
            value={name}
            onChange={handleNameChange}
            placeholder="Workspace Name"
            required
          />
          <br/>
          <input
            type="text"
            value={slug}
            readOnly
            placeholder="Workspace Slug"
          />
          <br/>
          <button type="submit">Grabar</button>
        </form>
      )}
    </div>
  );
};

export default WorkspaceForm;
